export default __webpack_public_path__ + "static/media/yaroslav.fa9a7b84.png";